// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grayscale{filter:grayscale(1)}.mainHeaderWrap{box-sizing:border-box;display:list-item;background:#d1e1f2!important;padding:.5rem .7rem;padding-right:1rem;text-align:left;width:calc(100% + 1px)}.menuBtn{float:right}.mainMenuIcon{width:1.8rem;margin-top:5px;-webkit-user-drag:none}.mainHeaderLogo{width:1.7rem;margin:0 .4rem;-webkit-user-drag:none}", ""]);
// Exports
module.exports = exports;
